import { IconButton } from '@/components/IconButton'
import { NumericSpinnerInput } from '@/components/inputs/NumericSpinnerInput'
import styles from './JobScopeCustomItem.module.css'

export interface JobScopeCustomItemProps {
  name: string
  price: number
  proPrice: number
  currentQuantity: number
  newQuantity: number
  isFromJobScope: boolean
  onRemove: () => unknown
  onQuantityChange: (value: number | null) => unknown
  itemTestId?: string
}

export function JobScopeCustomItem({
  name,
  price,
  proPrice,
  currentQuantity,
  newQuantity,
  isFromJobScope,
  onRemove,
  onQuantityChange,
  itemTestId,
}: JobScopeCustomItemProps) {
  return (
    <div
      className={styles.customItemContainer}
      data-test="job-scope-update-item"
    >
      <IconButton
        name="close"
        label="Remove item"
        className={styles.removeCustomItemButton}
        onPress={onRemove}
        testId={`job-scope-update-custom-remove-button-${itemTestId}`}
        size={24}
      />

      <div className={styles.textContainer}>
        <div className={styles.title}>{name}</div>
        <div className={styles.priceContainer}>
          <div className={styles.price}>{'$' + price}</div>
          <div className={styles.priceSeparator}>|</div>
          <div className={styles.price}>{'$' + proPrice}</div>
        </div>
      </div>

      <div
        className={styles.currentQuantityContainer}
        data-test={`job-scope-update-custom-current-quantity-${itemTestId}`}
      >
        {currentQuantity}
      </div>

      <NumericSpinnerInput
        min={0}
        value={newQuantity}
        onChange={onQuantityChange}
        isDisabled={isFromJobScope}
        testId={`job-scope-update-custom-quantity-${itemTestId}`}
      />
    </div>
  )
}
